import { render, staticRenderFns } from "./jlsw.vue?vue&type=template&id=6a8646ac&scoped=true"
import script from "./jlsw.vue?vue&type=script&lang=js"
export * from "./jlsw.vue?vue&type=script&lang=js"
import style0 from "./jlsw.vue?vue&type=style&index=0&id=6a8646ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8646ac",
  null
  
)

export default component.exports